/**
 * Note Visibility Enum
 *
 * Determines who can see a note within a workspace.
 */
export enum NoteVisibility {
  /** Only the creator can see this note */
  Private = 'Private',
  /** All workspace members can see this note */
  Workspace = 'Workspace',
}
